import api from './api';

class AiService {
  chat(messages, timezone) {
    return api.post('/ai/chat', { messages, timezone });
  }

  uploadRagDocument(file) {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/ai/rag/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  ragChat(messages) {
    return api.post('/ai/rag/chat', { messages });
  }

  listRagDocuments() {
    return api.get('/ai/rag/documents');
  }

  deleteRagDocument(documentId) {
    return api.delete(`/ai/rag/documents/${documentId}`);
  }
}

export default new AiService();





